import { PaymentProcessorType } from '@fingertip/creator-proto/gen/fingertip/common/enum/v1/payment_processor_type_pb'
import { z } from 'zod'

const contactSchema = z
  .object({
    email: z.string().min(1, 'Email is required.'),
    emailOptin: z.boolean(),
    name: z.string().optional(),
  })
  .optional()

const createAddressSchema = ({
  nameRequired = false,
  required = false,
}: {
  nameRequired?: boolean
  required?: boolean
}) => {
  const schema = z.object({
    name: nameRequired
      ? z.string().min(1, 'Full name is required')
      : z.string().optional(),
    phone: z.string().optional(),
    address1: required
      ? z.string().min(1, 'Address is required')
      : z.string().optional(),
    address2: z.string().optional(),
    city: required
      ? z.string().min(1, 'City is required')
      : z.string().optional(),
    state: required
      ? z.string().min(1, 'State is required')
      : z.string().optional(),
    postalCode: required
      ? z.string().min(1, 'Postal code is required')
      : z.string().optional(),
    country: required
      ? z.string().min(1, 'Country is required')
      : z.string().optional(),
  })
  return required ? schema : schema.optional()
}

const paymentMethodSchema = z
  .object({
    stripePaymentMethodId: z.string(),
    stripePaymentIntentId: z.string(),
    paymentProcessorType: z.nativeEnum(PaymentProcessorType),
  })
  .optional()

export const createPaymentDetailsFormSchema = ({
  requiresShipping,
}: {
  requiresShipping: boolean
}) => {
  return z.object({
    contact: contactSchema,
    paymentMethod: paymentMethodSchema,
    billing: createAddressSchema({}),
    shipping: requiresShipping
      ? createAddressSchema({ nameRequired: true, required: true })
      : createAddressSchema({}),
    shippingRateId: requiresShipping
      ? z.string().min(1, 'Shipping rate is required')
      : z.string().optional(),
  })
}

export type PaymentDetailsFormSchema = z.infer<
  ReturnType<typeof createPaymentDetailsFormSchema>
>
